export const remoteFrequencyUnitValues = [
  { id: 1, key: 'WEEK', label: 'semaine' },
  { id: 2, key: 'MONTH', label: 'mois' },
  { id: 3, key: 'YEAR', label: 'an' },
];
